import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import CreateCustomOverlay from 'utils/search/customOverlay';

export const initializeOverlay = ({
	setOverlay,
	google,
	map,
	overlay,
	...props
}) => {
	if (map && google && !overlay) {
		const newOverlay = CreateCustomOverlay(google, map, props);
		setOverlay(newOverlay);
		return newOverlay;
	}
	return null;
};

export const enhance = () => {
	const EnhancedOverlay = (props) => {
		const { google, selected } = props;
		const [overlay, setOverlay] = useState(null);
		const prevGoogleRef = useRef(google);
		const prevSelectedRef = useRef(selected);
		const prevLabelTextRef = useRef(props.labelText);
		const prevLabelRef = useRef(props.label);
		const overlayRef = useRef(null);

		// Keep overlayRef in sync with state
		useEffect(() => {
			overlayRef.current = overlay;
		}, [overlay]);

		useEffect(() => {
			initializeOverlay({ ...props, overlay: null, setOverlay });
			return () => {
				if (overlayRef.current) {
					overlayRef.current.remove();
				}
			};
		}, []); // eslint-disable-line react-hooks/exhaustive-deps

		// Intentionally runs every render to detect google/selected/label changes via refs
		// eslint-disable-next-line react-hooks/exhaustive-deps
		useEffect(() => {
			const labelChanged =
				props.labelText !== undefined
					? prevLabelTextRef.current !== props.labelText
					: !isEqual(prevLabelRef.current, props.label);

			if (!prevGoogleRef.current && !!google && !overlay) {
				initializeOverlay({ ...props, overlay, setOverlay });
			} else if (
				overlay &&
				(!isEqual(prevSelectedRef.current, selected) || labelChanged)
			) {
				overlay.update(props);
			}
			prevGoogleRef.current = google;
			prevSelectedRef.current = selected;
			prevLabelTextRef.current = props.labelText;
			prevLabelRef.current = props.label;
		});

		return null;
	};
	EnhancedOverlay.propTypes = {
		google: PropTypes.object,
		selected: PropTypes.object,
		label: PropTypes.node,
		labelText: PropTypes.string,
	};
	return EnhancedOverlay;
};

export default enhance();
